import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const SimpleDatepicker = (props) => {
  const [SelectedDate, setSelectedDate] = useState(props.DefaultValue);

  // Define styles
  const useStyles = makeStyles(() => ({
    datePicker: {
      width: "100%", // Set width to 100% of parent container
      "& .MuiIconButton-root": {
        // Target the IconButton inside the DatePicker
        color: "#FB4764", // Set the color to purple
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        // Change border color when focused
        borderColor: "#FB4764",
      },
      ...props.style,
    },
  }));

  const handleDateChange = (date) => {
    if (date) {
      let NewDate = dayjs(date).format("YYYY-MM-DD");
      props.SaveNewDate(NewDate);
      setSelectedDate(NewDate);
    }
  };

  const isOlderThan13 = (dateString) => {
    // Calculate the date 13 years ago from today
    const date13YearsAgo = dayjs().subtract(13, "year");

    // Parse the input date
    const inputDate = dayjs(dateString);

    // Check if the input date is before the date 13 years ago
    return inputDate.isBefore(date13YearsAgo);
  };

  const classes = useStyles(); // Initialize styles

  // Calculate the maximum date (13 years ago from today)
  const maxDate = dayjs().subtract(13, "year");

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        {/* Apply custom styles to DatePicker */}
        <DatePicker
          label={props.Label}
          className={classes.datePicker}
          value={
            SelectedDate && isOlderThan13(SelectedDate)
              ? dayjs(SelectedDate)
              : null
          }
          onChange={handleDateChange}
          maxDate={maxDate}
          {...props.DatePickerProps}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default SimpleDatepicker;
